import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import Chip from "../../../../components/basics/Chip";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Btn from "../../../../components/buttons/Btn";
import { apportionment } from "../../../../utils/apportionment";
import { validNotNull } from "../../../../utils/validations";
import { HeaderModal } from "../../../financeiro/nfe/styles/Emissao";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";
import { ConfigurationContext } from "../contexts/ConfigurationContext";
import MaskService from "./../../../../utils/mask/maskService";
import { notify } from "./../../../../utils/notify";

import moment from "moment";
import "moment/locale/pt-br";

const ModalContasReceber = ({ editingItem = null, open, setOpen }) => {
  const { totalService, setItensInstallments, itensInstallments } = useContext(
    GerenciamentoContratoContext
  );

  const { configuration } = useContext(ConfigurationContext);

  const [chargeValue, setChargeValue] = useState("0,00");
  const [chargeError, setChargeError] = useState({});
  const [chargeDueDate, setChargeDueDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  const rmd = (value) => MaskService.removeMaskDecimal(value);

  useEffect(() => {
    if (!editingItem) return;

    setChargeValue(
      MaskService.toMask(
        "decimal",
        parseFloat(editingItem.value || "0.00000").toFixed(
          configuration?.contract_decimal_size || 2
        ),
        configuration?.contract_decimal_size || 2
      )
    );
    setChargeDueDate(moment(editingItem.dueDate).format("YYYY-MM-DD"));
  }, [editingItem, configuration]);

  useEffect(() => {
    if (rmd(chargeValue) > rmd(totalService)) {
      notify(
        "O valor das parcelas ultrapassou o total do contrato. Por favor, reveja a forma de pagamento para ajustar as parcelas."
      );
      setChargeValue(
        MaskService.toMask(
          "decimal",
          parseFloat(editingItem.value || "0.00000").toFixed(
            configuration?.contract_decimal_size || 2
          ),
          configuration?.contract_decimal_size || 2
        )
      );
    }
  }, [
    chargeValue,
    totalService,
    itensInstallments,
    editingItem?.value,
    configuration,
  ]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeItemData = (setOpen, setChargeError, setTable) => {
    let requiredFields = validNotNull([
      {
        key: "chargeDueDate",
        value: chargeDueDate,
      },
    ]);

    if (rmd(chargeValue) === 0) {
      requiredFields.error = true;
      requiredFields.errorsValidation = {
        ...requiredFields.errorsValidation,
        chargeValue: "Digite um valor maior que zero.",
      };
    }

    if (requiredFields.error) {
      setChargeError({ ...requiredFields.errorsValidation });
      return;
    }

    const copy = [...itensInstallments];

    const editedIndex = copy.findIndex(
      (e) => e.documentNumber === editingItem.documentNumber
    );

    const newDueDate = moment(chargeDueDate).format("YYYY-MM-DD");

    copy[editedIndex] = {
      ...copy[editedIndex],
      value: rmd(chargeValue),
      dueDate: newDueDate,
      edited: true,
    };

    const notEditedItems = copy.filter((e) => !e.edited).length;

    let totalEditedValue = 0;
    for (let index = 0; index < itensInstallments.length; index++) {
      if (editedIndex !== index) {
        const dateAjust =
          typeof itensInstallments[index].dueDate === "string"
            ? itensInstallments[index].dueDate
            : itensInstallments[index].dueDate.format("YYYY-MM-DD");
        if (dateAjust === newDueDate) {
          notify(
            "A data de vencimento deve ser ajustada, pois não é possível ter parcelas com a mesma data de vencimento."
          );
          return;
        }

        if (itensInstallments[index].edited) {
          totalEditedValue += itensInstallments[index].value;
        }
      }
    }

    const dividedValue = apportionment(
      rmd(totalService) - (totalEditedValue + rmd(chargeValue)),
      notEditedItems
    );
    const { parcel, rest } = dividedValue;
    const tempValue = rest ? parcel + rest : parcel;

    for (let i = itensInstallments.length - 1; i >= 0; i--) {
      if (!copy[i]?.edited) {
        copy[i] = {
          ...copy[i],
          value: tempValue ? Math.round(tempValue * 100) / 100 : 0,
        };
      }
    }

    setItensInstallments(copy);
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-cobranca"
    >
      <HeaderModal>
        <DialogTitle id="dialog-cobranca">
          <Chip label="COBRANÇA" bgcolor="primary" textcolor="white" />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container>
          <Grid container spacing={2}>
            <Grid item sm={6}>
              <TextFieldErp
                value={chargeValue}
                disabled={
                  itensInstallments.length === 1 ||
                  itensInstallments.filter((e) => !e.edited).length === 1
                }
                setValue={setChargeValue}
                mask="decimal"
                decimals={configuration?.contract_decimal_size || 2}
                size="small"
                label="Valor"
                error={chargeError.chargeValue ? true : false}
                helperText={chargeError.chargeValue || ""}
              />
            </Grid>
            <Grid item sm={6}>
              <TextFieldErp
                value={chargeDueDate}
                setValue={setChargeDueDate}
                type="date"
                size="small"
                label="Data de Vencimento"
                error={chargeError.chargeDueDate ? true : false}
                helperText={chargeError.chargeDueDate || ""}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn
          onClick={() => {
            handleChangeItemData(setOpen, setChargeError);
          }}
          label="incluir"
        />
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export { ModalContasReceber };
